import { patchUserProfile, PatchUserProfileInput, putUserEmergencyContact, PutUserEmergencyContactInput } from '@uplift/api';

import { useQueryClient } from '@tanstack/react-query';
import { useCurrentuser } from '@uplift/contexts';



export const useSaveProfile = () => {
  const queryClient = useQueryClient();
  const me = useCurrentuser();

  const saveProfile = async (profileUpdates: PatchUserProfileInput) => {
    try {
      await patchUserProfile(me.id, profileUpdates);
      await queryClient.invalidateQueries([ 'user', me.id, 'profile' ]);
    } catch (error) {
      console.error(error);

      return null;
    }
  };

  return saveProfile;
};


export const useSaveProfileEmergencyContact = () => {
  const queryClient = useQueryClient();

  const saveProfileEmergencyContact = async (userId: string, emergencyContactUpdate: PutUserEmergencyContactInput) => {
    try {
      await putUserEmergencyContact(userId, emergencyContactUpdate);
      await queryClient.invalidateQueries([ 'user', userId, 'emergencyContact' ]);
    } catch (error) {
      console.error(error);

      // TODO:FIXME: handle error

      return null;
    }
  };

  return saveProfileEmergencyContact;
};
